"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Admin6 = function Admin6(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 24 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 24 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Admin6' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Admin6' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Britive-Admin_Tenant-",
    transform: "translate(-23.000000, -463.000000)",
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "6",
    transform: "translate(23.000000, 463.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,0 L0.5,0 C0.2,0 0,0.2 0,0.5 L0,20 C0,20.3 0.2,20.5 0.5,20.5 L8.65,20.5 L7.35,23 L6.5,23 C6.2,23 6,23.2 6,23.5 C6,23.8 6.2,24 6.5,24 L17.5,24 C17.8,24 18,23.8 18,23.5 C18,23.2 17.8,23 17.5,23 L16.7,23 L15.4,20.5 L23.5,20.5 C23.8,20.5 24,20.3 24,20 L24,0.5 C24,0.2 23.8,0 23.5,0 Z M15.55,23 L8.45,23 L9.75,20.5 L14.25,20.5 L15.55,23 Z M23,19.5 L1,19.5 L1,18 L23,18 L23,19.5 Z M23,17 L1,17 L1,1 L23,1 L23,17 Z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.0179225,7.01361134 L15.431035,7.01361134 L15.431035,6.1107074 C15.431035,4.21460913 13.8960983,2.67967243 12,2.67967243 C10.1039017,2.67967243 8.56896504,4.21460913 8.56896504,6.1107074 L8.56896504,7.01361134 L7.98207748,7.01361134 C7.71120629,7.01361134 7.53062551,7.19419212 7.53062551,7.46506331 L7.53062551,14.8688756 C7.53062551,15.1397468 7.71120629,15.3203276 7.98207748,15.3203276 L16.0179225,15.3203276 C16.2887937,15.3203276 16.4693745,15.1397468 16.4693745,14.8688756 L16.4693745,7.46506331 C16.4693745,7.19419212 16.2887937,7.01361134 16.0179225,7.01361134 Z M9.47186897,6.1107074 C9.47186897,4.71120629 10.6004989,3.58257637 12,3.58257637 C13.3995011,3.58257637 14.528131,4.71120629 14.528131,6.1107074 L14.528131,7.01361134 L9.47186897,7.01361134 L9.47186897,6.1107074 Z M15.5664706,14.4174236 L8.43352944,14.4174236 L8.43352944,7.91651527 L15.5664706,7.91651527 L15.5664706,14.4174236 Z",
    id: "Shape",
    stroke: color,
    strokeWidth: "0.25"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,9.09029039 C11.2325317,9.09029039 10.6004989,9.72232315 10.6004989,10.4897915 C10.6004989,11.1218243 11.0068057,11.6184214 11.548548,11.8441474 L11.548548,12.8373417 C11.548548,13.1082129 11.7291288,13.2887937 12,13.2887937 C12.2708712,13.2887937 12.451452,13.1082129 12.451452,12.8373417 L12.451452,11.8441474 C12.9931943,11.6635666 13.3995011,11.1218243 13.3995011,10.4897915 C13.3995011,9.72232315 12.7674683,9.09029039 12,9.09029039 Z M12,10.9863887 C11.7291288,10.9863887 11.5034028,10.7606627 11.5034028,10.4897915 C11.5034028,10.2189203 11.7291288,9.99319433 12,9.99319433 C12.2708712,9.99319433 12.4965972,10.2189203 12.4965972,10.4897915 C12.4965972,10.7606627 12.2708712,10.9863887 12,10.9863887 Z",
    id: "Shape",
    stroke: color,
    strokeWidth: "0.25"
  })))));
};
Admin6.propTypes = _index.iconProps;
var _default = Admin6;
exports["default"] = _default;